import { render } from "./StatisticsComponent.vue?vue&type=template&id=ba2c4b0c&scoped=true"
import script from "./StatisticsComponent.vue?vue&type=script&lang=js"
export * from "./StatisticsComponent.vue?vue&type=script&lang=js"

import "./StatisticsComponent.vue?vue&type=style&index=0&id=ba2c4b0c&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2c4b0c"]])

export default __exports__